import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const CREATE_ADVISOR_SESSION_JOIN_CREDENTIALS = gql`
  mutation CreateAdvisorSessionJoinCredentials($input: CreateAdvisorSessionJoinCredentialsInput!) {
    createAdvisorSessionJoinCredentials(input: $input) {
      credentials {
        apiKey
        token
        userId
        userName
        callType
        callId
        enabled
      }
      advisorSession {
        ...AdvisorSessionFragment
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
